module.exports = __webpack_public_path__ + "static/media/GH.291fb5c3.png";